'use client'

import { memo } from 'react'
import Link from 'next/link'
import { Github } from 'lucide-react'
import { Button } from '@/components/ui/button'
import { FloatingIconsHero } from '@/components/ui/floating-icons-hero-section'
import { NINGENIE_CONNECT_PLATFORM_ICONS } from '@/app/(marketing)/_components/connect-platform-icons-ningenie'
import {
  NIN_CONNECT_PLATFORM_URL,
  NIN_GITHUB_URL,
  NIN_MCP_SERVER_URL,
} from '@/app/nin/_components/nin-org-links'

/** baby: Soft grid + glow matching the Ningenie /home landing aesthetic */
const NingenieSectionBackdrop = () => (
  <div className="pointer-events-none absolute inset-0 -z-10">
    <div className="absolute inset-0 bg-[linear-gradient(to_right,#f1f5f9_1px,transparent_1px),linear-gradient(to_bottom,#f1f5f9_1px,transparent_1px)] bg-[size:6rem_6rem]" />
    <div className="absolute right-1/2 h-72 w-[110%] translate-x-1/2 rounded-[60%] bg-[#21728d]/15 blur-3xl" />
  </div>
)

export const NingenieConnectPlatformSection = memo(function NingenieConnectPlatformSection() {
  return (
    <section
      id="connect-platform"
      className="relative overflow-hidden border-t border-slate-100 bg-[#F6F9FD] py-24"
      aria-labelledby="ningenie-connect-platform-heading"
    >
      <NingenieSectionBackdrop />

      <div className="relative z-10 mx-auto max-w-6xl px-6 md:px-10">
        <FloatingIconsHero
          className="min-h-[460px] bg-transparent py-8 md:min-h-[540px]"
          icons={NINGENIE_CONNECT_PLATFORM_ICONS}
          iconTileClassName="rounded-2xl border border-slate-100 bg-white shadow-lg shadow-slate-200/50 backdrop-blur-sm md:rounded-2xl"
          title={
            <>
              <div className="mb-6 inline-flex items-center gap-2 rounded-full border border-slate-200 bg-white px-3 py-1 text-xs font-medium text-slate-600 shadow-sm">
                <span className="flex h-2 w-2 rounded-full bg-[#21728d]" />
                Connect Platform
              </div>
              <h2
                id="ningenie-connect-platform-heading"
                className="mx-auto max-w-3xl text-3xl font-bold tracking-tight text-slate-900 md:text-5xl"
              >
                Plugins that power Genie.
              </h2>
            </>
          }
          subtitle={
            <p className="mx-auto mt-5 max-w-2xl text-base text-slate-500 md:text-lg">
              Open-source Connect platform with plugins you can self-host. Link Gmail, brokers,
              calendar, and MCP tools to Ningenie or NINX: you approve every connection.
            </p>
          }
          cta={
            <>
              <Button
                asChild
                className="h-11 rounded-md bg-[#21728d] px-6 text-white hover:bg-slate-800"
              >
                <Link href={NIN_CONNECT_PLATFORM_URL} target="_blank" rel="noopener noreferrer">
                  Open Connect
                </Link>
              </Button>
              <Button
                asChild
                variant="outline"
                className="h-11 rounded-md border-slate-200 bg-white px-6 text-slate-900 hover:bg-slate-50"
              >
                <Link href={NIN_MCP_SERVER_URL} target="_blank" rel="noopener noreferrer">
                  MCP plugins
                </Link>
              </Button>
              <Button
                asChild
                variant="outline"
                className="h-11 gap-2 rounded-md border-slate-200 bg-white px-6 text-slate-900 hover:bg-slate-50"
              >
                <Link href={NIN_GITHUB_URL} target="_blank" rel="noopener noreferrer">
                  <Github className="h-4 w-4" aria-hidden />
                  Source
                </Link>
              </Button>
            </>
          }
        />
      </div>
    </section>
  )
})
